<template>
  <p
    v-if="failure || success"
    class="field-label is-normal help"
    :class="{
      'has-text-primary': !!success,
      'has-text-danger': !!failure
    }"
  >
    {{ failure || success }}
  </p>
</template>

<script>
export default {
  name: "field-message",
  props: ["success", "failure"]
}
</script>
